var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBasketballSmallIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28268_41558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6006 2.99219C10.6668 3.93923 10.0657 5.21034 9.97217 6.61901H12.9998C12.9198 5.25388 12.3997 4.0021 11.6006 2.99219Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88086 0.5V6.61914H9.2107C9.30658 4.98343 10.0046 3.50704 11.0957 2.41857C10.0083 1.33378 8.51099 0.595545 6.88086 0.5Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97266 7.38086C10.0662 8.78951 10.6673 10.086 11.6011 11.0331C12.4002 10.0232 12.9202 8.74599 13.0002 7.38086H9.97266Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9043 2.41857C2.99541 3.50704 3.69342 4.98343 3.7893 6.61914H6.11914V0.5C4.48901 0.595545 2.99173 1.33378 1.9043 2.41857Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2107 7.38086H6.88086V13.5C8.51099 13.4045 10.0083 12.6916 11.0957 11.6068C10.0046 10.5184 9.30658 9.01657 9.2107 7.38086Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7893 7.38086C3.69342 9.01657 2.99541 10.5184 1.9043 11.6068C2.99173 12.6916 4.48901 13.4045 6.11914 13.5V7.38086H3.7893Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.38086C0.0800059 8.74599 0.600057 10.0232 1.39918 11.0331C2.33297 10.086 2.93404 8.78953 3.0276 7.38086H0Z",
    fill: "#78829D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39915 2.99219C0.600057 4.0021 0.0800059 5.25388 0 6.61901H3.02758C2.93404 5.21036 2.33294 3.93923 1.39915 2.99219Z",
    fill: "#78829D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28268_41558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBasketballSmallIcon);
export default ForwardRef;